import React, { Component, ReactNode, useEffect } from "react";
import Banner from "../../components/Banner/Banner";
import Tile from "../../components/Tile/Tile";
import SubFooter from "../../components/SubFooter/SubFooter";
import HomePageData from "../../json/homepage.json";
import MetaTag from "../../components/MetaTag/MetaTag";
import CSRProjectApproverData from "../../json/csrProjectApprovers.json";
import CSRPolicyContent from "../../components/CSR/cSRPolicyContent";
import CSRAnnualReport from "../../components/CSR/cSRAnnualReport";
import VideoPlayer from '../../components/VideoPlayer/VideoPlayer';

const csrBannerList = CSRProjectApproverData.bannerSection;
const CSR = () => {
    const handleBannerSearchText = (searchValue: any) => {
        console.log("searchValue", searchValue);
    };
    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: 'auto'
        });
    }, [])
    return (
        <>
            <MetaTag title={CSRProjectApproverData.title} description={CSRProjectApproverData.description} />
            <Banner
                isCarousle={false}
                bannerCardPosition={"center"}
                bannerCardColor={""}
                bannerImages={csrBannerList}
                stretchFullWidth={true}
                bannerClass={""}
                bannerJobContentFlag={false}
                handleBannerSearchText={handleBannerSearchText}
            />
            <div className="bgWhite pad-15-xs">
                <div className="container liquid-container">
                    <div className="csr-piller-list">
                        <div className="csr-piller-list-item">
                            <h2 className="bellSlimBold txtBlack">Policy</h2>
                            <p className="txtSize16">Our CSR programmes complies with BCE Global Tech CSR policy and Companies Act 2013.</p>
                            <div className="spacer30"></div>
                            <div className="csr-piller-list-btn">
                                <a href="/content/document/BCE-GTC-CSR-Policy.pdf" target="_blank" className="btn btn-default">View</a>
                            </div>
                        </div>
                        <div className="csr-piller-list-item">
                            <h2 className="bellSlimBold txtBlack">Committee</h2>
                            <p className="txtSize16">Our CSR committee ensures our programmes are robust, sustainable.</p>
                            <div className="spacer30"></div> 
                            {/*<table>*/}
                            {/*    <tr><td>Neel Mehta</td><td>President, BCE Global Tech</td></tr>*/}
                            {/*    <tr><td>Melanie Schweizer</td><td>SVP, Corp. Services & Corp. Sec- Bell</td></tr>*/}
                            {/*</table>*/}
                            <div className="csr-piller-list-btn">
                                <a href="/content/document/CSR_2026.pdf" target="_blank"  className="btn btn-default">View</a>
                            </div>
                        </div>
                        <div className="csr-piller-list-item">
                            <h2 className="bellSlimBold txtBlack">Projects</h2>
                            <p className="txtSize16">Our CSR Projects consistently strive to create positive impacts.</p>
                            <div className="spacer30"></div> 
                            <div className="csr-piller-list-btn">
                                <a href="/content/document/CSR-Annual-Action-Plan.pdf" target="_blank" className="btn btn-default">View</a>
                            </div>
                        </div>                        
                    </div>
                    <div className="spacer30"></div>
                    <div className="csr-video-container">
                        <div className="csr-video-list">
                            <div className="csr-video-list-item">
                                <VideoPlayer title={"Accessibility driven by Tech | Members from NAB talks about their experience with our technology"}
                                    description={""}
                                    videoLink={"https://www.youtube.com/watch?v=mTURrH6eDbY&feature=youtu.be"}
                                    controls={true}
                                    isExternal={true} />
                            </div>
                            <div className="csr-video-list-item">
                                <VideoPlayer title={"Accessibility driven by Partnership | Members from Mitti Cafe share their experiences"}
                                    description={""}
                                    videoLink={"https://www.youtube.com/watch?v=FJ_1Ip2AgWA&feature=youtu.be"}
                                    controls={true}
                                    isExternal={true} />
                            </div>
                        </div>
                    </div>

                    {/*<h3 className="bellSlimBold txtBlack txtBold letterSpacing txtSize26-xs margin-15-top">Our CSR Philosophy</h3>*/}
                    {/*<div className="spacer30"></div>                                                     */}
                    {/*<p className="txtSize16">At BCE Global Tech, we believe that technology, innovation, and human potential should work together to create a more inclusive and equitable society. Our Corporate Social Responsibility philosophy is rooted in the conviction that meaningful progress occurs when every individual, regardless of ability or circumstance, has access to opportunities that enable independence, dignity, and sustainable growth. Guided by the principle of "Tech that Connects: Connecting Need to Opportunity," we seek to bridge social gaps by empowering underserved and marginalized communities through education, skills development, livelihood enhancement, accessibility, and well-being initiatives. Our focus is on creating long-term, measurable impact that enables individuals to participate confidently and productively in society. We are particularly committed to advancing inclusion for persons with disabilities by supporting programs that foster mobility, digital literacy, employability, mental wellness, and sustainable livelihoods. Through strategic partnerships with credible implementing organizations and active employee engagement, we strive to build pathways to independence and social inclusion. Our CSR efforts are governed by transparency, accountability, ethical stewardship, and compliance with the Companies Act, 2013. We aspire to be a responsible corporate citizen that not only contributes financial resources but also leverages its expertise, people, and values to drive positive change in the communities we serve.</p>*/}
                    {/*<div className="spacer30"></div>*/}
                    {/*<div className="csr-av-container">*/}
                    {/*    <div className="csr-av-list">*/}
                    {/*        <div className="csr-av-list-item">*/}

                    {/*        </div>*/}
                    {/*    </div>*/}
                    {/*</div>*/}
                    {/*<div className="csr-piller-container">*/}
                    {/*    <h3 className="bellSlimBold txtBlack">Our CSR Pillars</h3>*/}
                    {/*    <div className="spacer10"></div> */}
                    {/*    <div className="csr-piller-list">*/}
                    {/*        <div className="csr-piller-list-item">*/}
                    {/*            <h4 className="bellSlimBold">Inclusive Empowerment</h4>*/}
                    {/*            <p>Advancing opportunities for persons with disabilities through education, skills, accessibility, and employability initiatives.</p>*/}
                    {/*        </div>*/}
                    {/*        <div className="csr-piller-list-item">*/}
                    {/*            <h4 className="bellSlimBold">Sustainable Livelihoods</h4>*/}
                    {/*            <p>Supporting vocational training and income-generating opportunities that foster long-term independence and economic participation.</p>*/}
                    {/*        </div>*/}
                    {/*        <div className="csr-piller-list-item">*/}
                    {/*            <h4 className="bellSlimBold">Learning and Digital Inclusion</h4>*/}
                    {/*            <p>Enabling access to education, technology, and digital skills that prepare individuals for a rapidly evolving world.</p>*/}
                    {/*        </div>*/}
                    {/*        <div className="csr-piller-list-item">*/}
                    {/*            <h4 className="bellSlimBold">Health and Well-being</h4>*/}
                    {/*            <p>Promoting mental wellness and holistic development to strengthen resilience and quality of life.</p>*/}
                    {/*        </div>*/}
                    {/*        <div className="csr-piller-list-item">*/}
                    {/*            <h4 className="bellSlimBold">Responsible Community Impact</h4>*/}
                    {/*            <p>Ensuring that all CSR investments are transparent, sustainable, measurable, and aligned with community needs and national development priorities.</p>*/}
                    {/*        </div>*/}
                    {/*    </div>*/}
                    {/*</div>*/}
                    {/*<CSRPolicyContent />                    */}
                    {/*<div className="spacer10"></div>*/}
                    {/*<div className="spacer10"></div>*/}
                    {/*<CSRAnnualReport />*/}
                    {/*<div className="spacer10"></div>*/}
                    <div className="spacer50"></div>
                </div>
            </div>
        </>
    )
};

export default CSR;